export default __webpack_public_path__ + "static/media/net-energy.76f910b7.png";